import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=236d694b"
import script from "./CreateCompany.vue?vue&type=script&lang=js"
export * from "./CreateCompany.vue?vue&type=script&lang=js"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=236d694b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports